module.exports = __webpack_public_path__ + "img/flavours.d67853f1.jpg";